"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendedMap_1 = __importDefault(require("./ExtendedMap"));
class Basic {
    constructor(options = {}) {
        this.options = options;
        this.cache = this.options.cache || new ExtendedMap_1.default();
    }
    /* istanbul ignore next */
    get _get() {
        return this.cache.get.bind(this.cache);
    }
    /* istanbul ignore next */
    get _add() {
        return this.cache.add.bind(this.cache);
    }
    /* istanbul ignore next */
    get _set() {
        return this.cache.set.bind(this.cache);
    }
    /* istanbul ignore next */
    get _has() {
        return this.cache.has.bind(this.cache);
    }
    /* istanbul ignore next */
    get _delete() {
        return this.cache.delete.bind(this.cache);
    }
    /* istanbul ignore next */
    get _forEach() {
        return this.cache.forEach.bind(this.cache);
    }
}
exports.Basic = Basic;
exports.default = Basic;
//# sourceMappingURL=index.js.map